import { fetchWithAuth } from '../utils/apiUtils';

export default class FleetsService {
  private static fleetsPath = 'asset/fleets';

  public static async getFleets() {
    return await fetchWithAuth(this.fleetsPath, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
  public static async addFleet(data: any) {
    return await fetchWithAuth(this.fleetsPath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  }

  public static async getFleet(id: string) {
    return await fetchWithAuth(`${this.fleetsPath}/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  public static async getDevicesInFleet(fleetId: string) {
    return await fetchWithAuth(
      `${this.fleetsPath}/${fleetId}/devices/`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }

  public static async updateFleet(fleetId: string, data: any) {
    return await fetchWithAuth(`${this.fleetsPath}/${fleetId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  }
}
